const SITE_KEY = (process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY || "").trim();

let scriptLoadPromise;

function loadEnterpriseScript(key) {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.grecaptcha?.enterprise?.execute) return Promise.resolve();

  if (!scriptLoadPromise) {
    scriptLoadPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = `https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(key)}`;
      s.async = true;
      s.defer = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error("reCAPTCHA script failed"));
      document.head.appendChild(s);
    });
  }
  return scriptLoadPromise;
}

/**
 * Runs invisible Enterprise execute; returns token or null when site key is not configured.
 * @param {string} action e.g. CUSTOMER_LOGIN (must match backend expectedAction)
 */
export async function executeRecaptchaEnterprise(action) {
  if (!SITE_KEY) return null;

  await loadEnterpriseScript(SITE_KEY);

  await new Promise((resolve) => {
    window.grecaptcha.enterprise.ready(resolve);
  });

  const token = await window.grecaptcha.enterprise.execute(SITE_KEY, {
    action: action || "LOGIN",
  });
  return token || null;
}
